export default {"src":"/_next/static/media/secured_by_aeropay.bab78a1b.svg","height":36,"width":113,"blurWidth":0,"blurHeight":0};